!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("styled-components"), require("react-dom")) : "function" == typeof define && define.amd ? define(["exports", "react", "styled-components", "react-dom"], t) : t((e = e || self)["react-snackbar-alert"] = {}, e.React, e.styled, e.ReactDOM);
}(this, function (e, p, t, n) {
  "use strict";

  var d = "default" in p ? p.default : p,
      r = "default" in t ? t.default : t,
      o = "default" in n ? n.default : n;

  function i(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function a(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function s(e, t, n) {
    return t && a(e.prototype, t), n && a(e, n), e;
  }

  function u() {
    return (u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && f(e, t);
  }

  function l(e) {
    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function f(e, t) {
    return (f = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function m(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function y(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? m(e) : t;
  }

  function v(e, t) {
    return t = t || e.slice(0), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }

  function h(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function b(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function g(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  var E = g(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = "function" == typeof Symbol && Symbol.for,
        r = n ? Symbol.for("react.element") : 60103,
        o = n ? Symbol.for("react.portal") : 60106,
        i = n ? Symbol.for("react.fragment") : 60107,
        a = n ? Symbol.for("react.strict_mode") : 60108,
        s = n ? Symbol.for("react.profiler") : 60114,
        u = n ? Symbol.for("react.provider") : 60109,
        c = n ? Symbol.for("react.context") : 60110,
        l = n ? Symbol.for("react.async_mode") : 60111,
        p = n ? Symbol.for("react.concurrent_mode") : 60111,
        f = n ? Symbol.for("react.forward_ref") : 60112,
        d = n ? Symbol.for("react.suspense") : 60113,
        m = n ? Symbol.for("react.memo") : 60115,
        y = n ? Symbol.for("react.lazy") : 60116;

    function v(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case r:
            switch (e = e.type) {
              case l:
              case p:
              case i:
              case s:
              case a:
              case d:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case c:
                  case f:
                  case u:
                    return e;

                  default:
                    return t;
                }

            }

          case y:
          case m:
          case o:
            return t;
        }
      }
    }

    function h(e) {
      return v(e) === p;
    }

    t.typeOf = v, t.AsyncMode = l, t.ConcurrentMode = p, t.ContextConsumer = c, t.ContextProvider = u, t.Element = r, t.ForwardRef = f, t.Fragment = i, t.Lazy = y, t.Memo = m, t.Portal = o, t.Profiler = s, t.StrictMode = a, t.Suspense = d, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === p || e === s || e === a || e === d || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === m || e.$$typeof === u || e.$$typeof === c || e.$$typeof === f);
    }, t.isAsyncMode = function (e) {
      return h(e) || v(e) === l;
    }, t.isConcurrentMode = h, t.isContextConsumer = function (e) {
      return v(e) === c;
    }, t.isContextProvider = function (e) {
      return v(e) === u;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === r;
    }, t.isForwardRef = function (e) {
      return v(e) === f;
    }, t.isFragment = function (e) {
      return v(e) === i;
    }, t.isLazy = function (e) {
      return v(e) === y;
    }, t.isMemo = function (e) {
      return v(e) === m;
    }, t.isPortal = function (e) {
      return v(e) === o;
    }, t.isProfiler = function (e) {
      return v(e) === s;
    }, t.isStrictMode = function (e) {
      return v(e) === a;
    }, t.isSuspense = function (e) {
      return v(e) === d;
    };
  });
  b(E);
  E.typeOf, E.AsyncMode, E.ConcurrentMode, E.ContextConsumer, E.ContextProvider, E.Element, E.ForwardRef, E.Fragment, E.Lazy, E.Memo, E.Portal, E.Profiler, E.StrictMode, E.Suspense, E.isValidElementType, E.isAsyncMode, E.isConcurrentMode, E.isContextConsumer, E.isContextProvider, E.isElement, E.isForwardRef, E.isFragment, E.isLazy, E.isMemo, E.isPortal, E.isProfiler, E.isStrictMode, E.isSuspense;
  var x = g(function (e, _) {
    "production" !== process.env.NODE_ENV && function () {
      Object.defineProperty(_, "__esModule", {
        value: !0
      });
      var e = "function" == typeof Symbol && Symbol.for,
          o = e ? Symbol.for("react.element") : 60103,
          i = e ? Symbol.for("react.portal") : 60106,
          a = e ? Symbol.for("react.fragment") : 60107,
          s = e ? Symbol.for("react.strict_mode") : 60108,
          u = e ? Symbol.for("react.profiler") : 60114,
          c = e ? Symbol.for("react.provider") : 60109,
          l = e ? Symbol.for("react.context") : 60110,
          p = e ? Symbol.for("react.async_mode") : 60111,
          f = e ? Symbol.for("react.concurrent_mode") : 60111,
          d = e ? Symbol.for("react.forward_ref") : 60112,
          m = e ? Symbol.for("react.suspense") : 60113,
          y = e ? Symbol.for("react.memo") : 60115,
          v = e ? Symbol.for("react.lazy") : 60116;

      var t = function t(e, _t) {
        if (void 0 === _t) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");

        if (!e) {
          for (var n = arguments.length, r = Array(2 < n ? n - 2 : 0), o = 2; o < n; o++) {
            r[o - 2] = arguments[o];
          }

          (function (e) {
            for (var t = arguments.length, n = Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            var o = 0,
                i = "Warning: " + e.replace(/%s/g, function () {
              return n[o++];
            });
            "undefined" != typeof console && console.warn(i);

            try {
              throw new Error(i);
            } catch (e) {}
          }).apply(void 0, [_t].concat(r));
        }
      };

      function n(e) {
        if ("object" == typeof e && null !== e) {
          var t = e.$$typeof;

          switch (t) {
            case o:
              var n = e.type;

              switch (n) {
                case p:
                case f:
                case a:
                case u:
                case s:
                case m:
                  return n;

                default:
                  var r = n && n.$$typeof;

                  switch (r) {
                    case l:
                    case d:
                    case c:
                      return r;

                    default:
                      return t;
                  }

              }

            case v:
            case y:
            case i:
              return t;
          }
        }
      }

      var r = p,
          h = f,
          b = l,
          g = c,
          E = o,
          x = d,
          O = a,
          w = v,
          k = y,
          C = i,
          S = u,
          T = s,
          P = m,
          N = !1;

      function j(e) {
        return n(e) === f;
      }

      _.typeOf = n, _.AsyncMode = r, _.ConcurrentMode = h, _.ContextConsumer = b, _.ContextProvider = g, _.Element = E, _.ForwardRef = x, _.Fragment = O, _.Lazy = w, _.Memo = k, _.Portal = C, _.Profiler = S, _.StrictMode = T, _.Suspense = P, _.isValidElementType = function (e) {
        return "string" == typeof e || "function" == typeof e || e === a || e === f || e === u || e === s || e === m || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === y || e.$$typeof === c || e.$$typeof === l || e.$$typeof === d);
      }, _.isAsyncMode = function (e) {
        return N || t(!(N = !0), "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API."), j(e) || n(e) === p;
      }, _.isConcurrentMode = j, _.isContextConsumer = function (e) {
        return n(e) === l;
      }, _.isContextProvider = function (e) {
        return n(e) === c;
      }, _.isElement = function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === o;
      }, _.isForwardRef = function (e) {
        return n(e) === d;
      }, _.isFragment = function (e) {
        return n(e) === a;
      }, _.isLazy = function (e) {
        return n(e) === v;
      }, _.isMemo = function (e) {
        return n(e) === y;
      }, _.isPortal = function (e) {
        return n(e) === i;
      }, _.isProfiler = function (e) {
        return n(e) === u;
      }, _.isStrictMode = function (e) {
        return n(e) === s;
      }, _.isSuspense = function (e) {
        return n(e) === m;
      };
    }();
  });
  b(x);
  x.typeOf, x.AsyncMode, x.ConcurrentMode, x.ContextConsumer, x.ContextProvider, x.Element, x.ForwardRef, x.Fragment, x.Lazy, x.Memo, x.Portal, x.Profiler, x.StrictMode, x.Suspense, x.isValidElementType, x.isAsyncMode, x.isConcurrentMode, x.isContextConsumer, x.isContextProvider, x.isElement, x.isForwardRef, x.isFragment, x.isLazy, x.isMemo, x.isPortal, x.isProfiler, x.isStrictMode, x.isSuspense;
  var O = g(function (e) {
    "production" === process.env.NODE_ENV ? e.exports = E : e.exports = x;
  }),
      w = Object.getOwnPropertySymbols,
      k = Object.prototype.hasOwnProperty,
      C = Object.prototype.propertyIsEnumerable;

  var S = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, o = function (e) {
      if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }(e), i = 1; i < arguments.length; i++) {
      for (var a in n = Object(arguments[i])) {
        k.call(n, a) && (o[a] = n[a]);
      }

      if (w) {
        r = w(n);

        for (var s = 0; s < r.length; s++) {
          C.call(n, r[s]) && (o[r[s]] = n[r[s]]);
        }
      }
    }

    return o;
  },
      T = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
      P = function P() {};

  if ("production" !== process.env.NODE_ENV) {
    var N = T,
        j = {},
        _ = Function.call.bind(Object.prototype.hasOwnProperty);

    P = function P(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);

      try {
        throw new Error(t);
      } catch (e) {}
    };
  }

  function M(e, t, n, r, o) {
    if ("production" !== process.env.NODE_ENV) for (var i in e) {
      if (_(e, i)) {
        var a;

        try {
          if ("function" != typeof e[i]) {
            var s = Error((r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.");
            throw s.name = "Invariant Violation", s;
          }

          a = e[i](t, i, r, n, null, N);
        } catch (e) {
          a = e;
        }

        if (!a || a instanceof Error || P((r || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof a + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in j)) {
          j[a.message] = !0;
          var u = o ? o() : "";
          P("Failed " + n + " type: " + a.message + (null != u ? u : ""));
        }
      }
    }
  }

  M.resetWarningCache = function () {
    "production" !== process.env.NODE_ENV && (j = {});
  };

  var R = M,
      V = Function.call.bind(Object.prototype.hasOwnProperty),
      A = function A() {};

  function D() {
    return null;
  }

  "production" !== process.env.NODE_ENV && (A = function A(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  });

  function $(a, f) {
    var i = "function" == typeof Symbol && Symbol.iterator,
        s = "@@iterator",
        d = "<<anonymous>>",
        e = {
      array: t("array"),
      bool: t("boolean"),
      func: t("function"),
      number: t("number"),
      object: t("object"),
      string: t("string"),
      symbol: t("symbol"),
      any: n(D),
      arrayOf: function arrayOf(u) {
        return n(function (e, t, n, r, o) {
          if ("function" != typeof u) return new m("Property `" + o + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
          var i = e[t];
          if (!Array.isArray(i)) return new m("Invalid " + r + " `" + o + "` of type `" + y(i) + "` supplied to `" + n + "`, expected an array.");

          for (var a = 0; a < i.length; a++) {
            var s = u(i, a, n, r, o + "[" + a + "]", T);
            if (s instanceof Error) return s;
          }

          return null;
        });
      },
      element: n(function (e, t, n, r, o) {
        var i = e[t];
        return a(i) ? null : new m("Invalid " + r + " `" + o + "` of type `" + y(i) + "` supplied to `" + n + "`, expected a single ReactElement.");
      }),
      elementType: n(function (e, t, n, r, o) {
        var i = e[t];
        return O.isValidElementType(i) ? null : new m("Invalid " + r + " `" + o + "` of type `" + y(i) + "` supplied to `" + n + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(a) {
        return n(function (e, t, n, r, o) {
          if (e[t] instanceof a) return null;
          var i = a.name || d;
          return new m("Invalid " + r + " `" + o + "` of type `" + function (e) {
            return e.constructor && e.constructor.name ? e.constructor.name : d;
          }(e[t]) + "` supplied to `" + n + "`, expected instance of `" + i + "`.");
        });
      },
      node: n(function (e, t, n, r, o) {
        return u(e[t]) ? null : new m("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(c) {
        return n(function (e, t, n, r, o) {
          if ("function" != typeof c) return new m("Property `" + o + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
          var i = e[t],
              a = y(i);
          if ("object" !== a) return new m("Invalid " + r + " `" + o + "` of type `" + a + "` supplied to `" + n + "`, expected an object.");

          for (var s in i) {
            if (V(i, s)) {
              var u = c(i, s, n, r, o + "." + s, T);
              if (u instanceof Error) return u;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(u) {
        if (!Array.isArray(u)) return "production" !== process.env.NODE_ENV && A(1 < arguments.length ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), D;
        return n(function (e, t, n, r, o) {
          for (var i = e[t], a = 0; a < u.length; a++) {
            if (c(i, u[a])) return null;
          }

          var s = JSON.stringify(u, function (e, t) {
            return "symbol" === l(t) ? String(t) : t;
          });
          return new m("Invalid " + r + " `" + o + "` of value `" + String(i) + "` supplied to `" + n + "`, expected one of " + s + ".");
        });
      },
      oneOfType: function oneOfType(a) {
        if (!Array.isArray(a)) return "production" !== process.env.NODE_ENV && A("Invalid argument supplied to oneOfType, expected an instance of array."), D;

        for (var e = 0; e < a.length; e++) {
          var t = a[e];
          if ("function" != typeof t) return A("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + r(t) + " at index " + e + "."), D;
        }

        return n(function (e, t, n, r, o) {
          for (var i = 0; i < a.length; i++) {
            if (null == (0, a[i])(e, t, n, r, o, T)) return null;
          }

          return new m("Invalid " + r + " `" + o + "` supplied to `" + n + "`.");
        });
      },
      shape: function shape(l) {
        return n(function (e, t, n, r, o) {
          var i = e[t],
              a = y(i);
          if ("object" !== a) return new m("Invalid " + r + " `" + o + "` of type `" + a + "` supplied to `" + n + "`, expected `object`.");

          for (var s in l) {
            var u = l[s];

            if (u) {
              var c = u(i, s, n, r, o + "." + s, T);
              if (c) return c;
            }
          }

          return null;
        });
      },
      exact: function exact(p) {
        return n(function (e, t, n, r, o) {
          var i = e[t],
              a = y(i);
          if ("object" !== a) return new m("Invalid " + r + " `" + o + "` of type `" + a + "` supplied to `" + n + "`, expected `object`.");
          var s = S({}, e[t], p);

          for (var u in s) {
            var c = p[u];
            if (!c) return new m("Invalid " + r + " `" + o + "` key `" + u + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(e[t], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(p), null, "  "));
            var l = c(i, u, n, r, o + "." + u, T);
            if (l) return l;
          }

          return null;
        });
      }
    };

    function c(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }

    function m(e) {
      this.message = e, this.stack = "";
    }

    function n(c) {
      if ("production" !== process.env.NODE_ENV) var l = {},
          p = 0;

      function e(e, t, n, r, o, i, a) {
        if (r = r || d, i = i || n, a !== T) {
          if (f) {
            var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw s.name = "Invariant Violation", s;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var u = r + ":" + n;
            !l[u] && p < 3 && (A("You are manually calling a React.PropTypes validation function for the `" + i + "` prop on `" + r + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), l[u] = !0, p++);
          }
        }

        return null == t[n] ? e ? null === t[n] ? new m("The " + o + " `" + i + "` is marked as required in `" + r + "`, but its value is `null`.") : new m("The " + o + " `" + i + "` is marked as required in `" + r + "`, but its value is `undefined`.") : null : c(t, n, r, o, i);
      }

      var t = e.bind(null, !1);
      return t.isRequired = e.bind(null, !0), t;
    }

    function t(s) {
      return n(function (e, t, n, r, o, i) {
        var a = e[t];
        return y(a) === s ? null : new m("Invalid " + r + " `" + o + "` of type `" + l(a) + "` supplied to `" + n + "`, expected `" + s + "`.");
      });
    }

    function u(e) {
      switch (typeof e) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !e;

        case "object":
          if (Array.isArray(e)) return e.every(u);
          if (null === e || a(e)) return !0;

          var t = function (e) {
            var t = e && (i && e[i] || e[s]);
            if ("function" == typeof t) return t;
          }(e);

          if (!t) return !1;
          var n,
              r = t.call(e);

          if (t !== e.entries) {
            for (; !(n = r.next()).done;) {
              if (!u(n.value)) return !1;
            }
          } else for (; !(n = r.next()).done;) {
            var o = n.value;
            if (o && !u(o[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function y(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, e) ? "symbol" : t;
    }

    function l(e) {
      if (null == e) return "" + e;
      var t = y(e);

      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }

      return t;
    }

    function r(e) {
      var t = l(e);

      switch (t) {
        case "array":
        case "object":
          return "an " + t;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;

        default:
          return t;
      }
    }

    return m.prototype = Error.prototype, e.checkPropTypes = R, e.resetWarningCache = R.resetWarningCache, e.PropTypes = e;
  }

  function I() {}

  function L() {}

  L.resetWarningCache = I;
  var z = g(function (e) {
    if ("production" !== process.env.NODE_ENV) {
      var t = O;
      e.exports = $(t.isElement, !0);
    } else e.exports = function () {
      function e(e, t, n, r, o, i) {
        if (i !== T) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }

      function t() {
        return e;
      }

      var n = {
        array: e.isRequired = e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: L,
        resetWarningCache: I
      };
      return n.PropTypes = n;
    }();
  }),
      F = z.bool,
      B = z.element,
      H = z.func,
      q = z.oneOfType;

  function W() {
    var e = v(["\n  fill: currentColor;\n"]);
    return W = function W() {
      return e;
    }, e;
  }

  var U = r.svg(W());

  function Y() {
    return d.createElement(U, {
      viewBox: "0 0 12 16",
      style: {
        width: "12px",
        height: "16px"
      }
    }, d.createElement("path", {
      fillRule: "evenodd",
      d: "M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48L7.48 8z"
    }));
  }

  var J = {
    default: {
      color: "rgba(0, 0, 0, 0.9)"
    },
    info: {
      color: "rgba(0, 180, 255, 0.95)",
      icon: function icon() {
        return d.createElement(U, {
          viewBox: "0 0 14 16",
          style: {
            width: "20px",
            height: "20px"
          }
        }, d.createElement("path", {
          fillRule: "evenodd",
          d: "M6.3 5.69a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.7.19-.18.42-.28.7-.28.28 0 .52.09.7.28.18.19.28.42.28.7 0 .28-.09.52-.28.7a1 1 0 0 1-.7.3c-.28 0-.52-.11-.7-.3zM8 7.99c-.02-.25-.11-.48-.31-.69-.2-.19-.42-.3-.69-.31H6c-.27.02-.48.13-.69.31-.2.2-.3.44-.31.69h1v3c.02.27.11.5.31.69.2.2.42.31.69.31h1c.27 0 .48-.11.69-.31.2-.19.3-.42.31-.69H8V7.98v.01zM7 2.3c-3.14 0-5.7 2.54-5.7 5.68 0 3.14 2.56 5.7 5.7 5.7s5.7-2.55 5.7-5.7c0-3.15-2.56-5.69-5.7-5.69v.01zM7 .98c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.12-7-7 3.14-7 7-7z"
        }));
      }
    },
    success: {
      color: "rgba(127, 175, 27, 0.95)",
      icon: function icon() {
        return d.createElement(U, {
          viewBox: "0 0 12 16",
          style: {
            width: "20px",
            height: "20px"
          }
        }, d.createElement("path", {
          fillRule: "evenodd",
          d: "M12 5l-8 8-4-4 1.5-1.5L4 10l6.5-6.5L12 5z"
        }));
      }
    },
    warning: {
      color: "rgba(240, 123, 6, 0.95)",
      icon: function icon() {
        return d.createElement(U, {
          viewBox: "0 0 16 16",
          style: {
            width: "20px",
            height: "20px"
          }
        }, d.createElement("path", {
          fillRule: "evenodd",
          d: "M8.893 1.5c-.183-.31-.52-.5-.887-.5s-.703.19-.886.5L.138 13.499a.98.98 0 0 0 0 1.001c.193.31.53.501.886.501h13.964c.367 0 .704-.19.877-.5a1.03 1.03 0 0 0 .01-1.002L8.893 1.5zm.133 11.497H6.987v-2.003h2.039v2.003zm0-3.004H6.987V5.987h2.039v4.006z"
        }));
      }
    },
    error: {
      color: "rgba(211, 0, 0, 0.95)",
      icon: function icon() {
        return d.createElement(U, {
          viewBox: "0 0 14 16",
          style: {
            width: "20px",
            height: "20px"
          }
        }, d.createElement("path", {
          fillRule: "evenodd",
          d: "M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
        }));
      }
    }
  };

  function G(e) {
    return J[e] || J.default;
  }

  var X = Object.keys(J);

  function K() {
    var e = v(["\n  align-self: flex-start;\n  width: calc(100% + 1em);\n  height: 0.25em;\n  background: rgba(255, 255, 255, 0.4);\n  position: relative;\n  top: 0.25em;\n  left: -0.5em;\n  border-bottom-left-radius: 5px;\n  animation-name: ", ";\n  animation-duration: ", "ms;\n  animation-timing-function: linear;\n"]);
    return K = function K() {
      return e;
    }, e;
  }

  function Q() {
    var e = v(["\n  background: transparent;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  font-size: 1.5em;\n  outline: none;\n  width: 1em;\n"]);
    return Q = function Q() {
      return e;
    }, e;
  }

  function Z() {
    var e = v(["\n  flex-grow: 1;\n"]);
    return Z = function Z() {
      return e;
    }, e;
  }

  function ee() {
    var e = v(["\n  flex-grow: 1;\n  max-width: 20em;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"]);
    return ee = function ee() {
      return e;
    }, e;
  }

  function te() {
    var e = v(["\n  margin-right: 0.5em;\n"]);
    return te = function te() {
      return e;
    }, e;
  }

  function ne() {
    var e = v(["\n  background: ", ";\n  border-radius: 5px;\n  color: #ffffff;\n  min-height: 3em;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0.25em 0.5em;\n  margin-bottom: ", ";\n  margin-top: ", ";\n"]);
    return ne = function ne() {
      return e;
    }, e;
  }

  function re() {
    var e = v(["\n  0% {\n    width: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  99% {\n    border-bottom-right-radius: 0;\n  }\n\n  100% {\n    width: 102%;\n    border-bottom-right-radius: 5px;\n  }\n"]);
    return re = function re() {
      return e;
    }, e;
  }

  var oe = t.keyframes(re()),
      ie = r.div(ne(), function (e) {
    return G(e.theme).color;
  }, function (e) {
    return 0 === e.position.indexOf("bottom") ? "0.5em" : 0;
  }, function (e) {
    return 0 === e.position.indexOf("top") ? "0.5em" : 0;
  }),
      ae = r.div(te()),
      se = r.div(ee()),
      ue = r.div(Z()),
      ce = r.button(Q()),
      le = r.div(K(), oe, function (e) {
    return e.timeout;
  }),
      pe = function () {
    function n(e) {
      var t;
      return i(this, n), (t = y(this, l(n).call(this, e))).state = {
        animationPaused: !1
      }, t.pause = t.pause.bind(m(t)), t.resume = t.resume.bind(m(t)), t;
    }

    return c(n, d.Component), s(n, [{
      key: "pause",
      value: function value() {
        this.props.pauseOnHover && (this.setState({
          animationPaused: !0
        }), this.props.onPause());
      }
    }, {
      key: "resume",
      value: function value() {
        this.props.pauseOnHover && (this.setState({
          animationPaused: !1
        }), this.props.onResume());
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.timeout,
            n = e.children,
            r = e.dismissable,
            o = e.message,
            i = e.onDismiss,
            a = e.sticky,
            s = e.progressBar,
            u = e.position,
            c = e.theme,
            l = G(c).icon;
        return d.createElement("div", {
          style: {
            display: "flex"
          },
          onMouseEnter: this.pause,
          onMouseLeave: this.resume
        }, d.createElement(ie, {
          position: u,
          theme: c
        }, d.createElement(se, null, l ? d.createElement(ae, null, d.createElement(l, null)) : null, d.createElement(ue, {
          dismissable: r
        }, n || o), r ? d.createElement(ce, {
          title: "Close",
          onClick: i
        }, d.createElement(Y, null)) : null), !a && s ? d.createElement(le, {
          role: "progressbar",
          timeout: t,
          className: "react-snackbar-alert__snackbar-progress-bar",
          style: {
            animationPlayState: this.state.animationPaused ? "paused" : "running"
          }
        }) : null));
      }
    }]), n;
  }();

  pe.defaultProps = {
    progressBar: !0,
    position: "bottom"
  }, pe.propTypes = {
    children: z.node,
    pauseOnHover: z.bool,
    onPause: z.func,
    onResume: z.func,
    timeout: z.number,
    theme: z.oneOf(X),
    dismissable: z.bool,
    message: z.string,
    onDismiss: z.func,
    sticky: z.bool,
    progressBar: z.bool,
    position: z.oneOf(["top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right"])
  };

  for (var fe = g(function (e) {
    var t = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (t) {
      var n = new Uint8Array(16);

      e.exports = function () {
        return t(n), n;
      };
    } else {
      var r = new Array(16);

      e.exports = function () {
        for (var e, t = 0; t < 16; t++) {
          0 == (3 & t) && (e = 4294967296 * Math.random()), r[t] = e >>> ((3 & t) << 3) & 255;
        }

        return r;
      };
    }
  }), de = [], me = 0; me < 256; ++me) {
    de[me] = (me + 256).toString(16).substr(1);
  }

  var ye = function ye(e, t) {
    var n = t || 0,
        r = de;
    return [r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]]].join("");
  };

  var ve = function ve(e, t, n) {
    var r = t && n || 0;
    "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
    var o = (e = e || {}).random || (e.rng || fe)();
    if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) for (var i = 0; i < 16; ++i) {
      t[r + i] = o[i];
    }
    return t || ye(o);
  };

  function he() {
    return (he = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function be(e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], 0 <= t.indexOf(n) || (o[n] = e[n]);
    }

    return o;
  }

  function ge(e, t) {
    e.prototype = Object.create(t.prototype), (e.prototype.constructor = e).__proto__ = t;
  }

  var Ee = g(function (e) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  });
  b(Ee);
  var xe = g(function (e, t) {
    t.__esModule = !0, t.default = function (e, t) {
      return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
    }, e.exports = t.default;
  });
  b(xe);
  var Oe = b(g(function (e, t) {
    t.__esModule = !0, t.default = function (e, t) {
      e.classList ? e.classList.add(t) : (0, n.default)(e, t) || ("string" == typeof e.className ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
    };
    var n = Ee(xe);
    e.exports = t.default;
  }));

  function we(e, t) {
    return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
  }

  var ke = !1,
      Ce = "production" !== process.env.NODE_ENV ? z.oneOfType([z.number, z.shape({
    enter: z.number,
    exit: z.number,
    appear: z.number
  }).isRequired]) : null,
      Se = "production" !== process.env.NODE_ENV ? z.oneOfType([z.string, z.shape({
    enter: z.string,
    exit: z.string,
    active: z.string
  }), z.shape({
    enter: z.string,
    enterDone: z.string,
    enterActive: z.string,
    exit: z.string,
    exitDone: z.string,
    exitActive: z.string
  })]) : null,
      Te = d.createContext(null),
      Pe = "unmounted",
      Ne = "exited",
      je = "entering",
      _e = "entered",
      Me = "exiting",
      Re = function (i) {
    function e(e, t) {
      var n;
      n = i.call(this, e, t) || this;
      var r,
          o = t && !t.isMounting ? e.enter : e.appear;
      return n.appearStatus = null, e.in ? o ? (r = Ne, n.appearStatus = je) : r = _e : r = e.unmountOnExit || e.mountOnEnter ? Pe : Ne, n.state = {
        status: r
      }, n.nextCallback = null, n;
    }

    ge(e, i), e.getDerivedStateFromProps = function (e, t) {
      return e.in && t.status === Pe ? {
        status: Ne
      } : null;
    };
    var t = e.prototype;
    return t.componentDidMount = function () {
      this.updateStatus(!0, this.appearStatus);
    }, t.componentDidUpdate = function (e) {
      var t = null;

      if (e !== this.props) {
        var n = this.state.status;
        this.props.in ? n !== je && n !== _e && (t = je) : n !== je && n !== _e || (t = Me);
      }

      this.updateStatus(!1, t);
    }, t.componentWillUnmount = function () {
      this.cancelNextCallback();
    }, t.getTimeouts = function () {
      var e,
          t,
          n,
          r = this.props.timeout;
      return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
        exit: e,
        enter: t,
        appear: n
      };
    }, t.updateStatus = function (e, t) {
      if (void 0 === e && (e = !1), null !== t) {
        this.cancelNextCallback();
        var n = o.findDOMNode(this);
        t === je ? this.performEnter(n, e) : this.performExit(n);
      } else this.props.unmountOnExit && this.state.status === Ne && this.setState({
        status: Pe
      });
    }, t.performEnter = function (e, t) {
      var n = this,
          r = this.props.enter,
          o = this.context ? this.context.isMounting : t,
          i = this.getTimeouts(),
          a = o ? i.appear : i.enter;
      !t && !r || ke ? this.safeSetState({
        status: _e
      }, function () {
        n.props.onEntered(e);
      }) : (this.props.onEnter(e, o), this.safeSetState({
        status: je
      }, function () {
        n.props.onEntering(e, o), n.onTransitionEnd(e, a, function () {
          n.safeSetState({
            status: _e
          }, function () {
            n.props.onEntered(e, o);
          });
        });
      }));
    }, t.performExit = function (e) {
      var t = this,
          n = this.props.exit,
          r = this.getTimeouts();
      n && !ke ? (this.props.onExit(e), this.safeSetState({
        status: Me
      }, function () {
        t.props.onExiting(e), t.onTransitionEnd(e, r.exit, function () {
          t.safeSetState({
            status: Ne
          }, function () {
            t.props.onExited(e);
          });
        });
      })) : this.safeSetState({
        status: Ne
      }, function () {
        t.props.onExited(e);
      });
    }, t.cancelNextCallback = function () {
      null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
    }, t.safeSetState = function (e, t) {
      t = this.setNextCallback(t), this.setState(e, t);
    }, t.setNextCallback = function (t) {
      var n = this,
          r = !0;
      return this.nextCallback = function (e) {
        r && (r = !1, n.nextCallback = null, t(e));
      }, this.nextCallback.cancel = function () {
        r = !1;
      }, this.nextCallback;
    }, t.onTransitionEnd = function (e, t, n) {
      this.setNextCallback(n);
      var r = null == t && !this.props.addEndListener;
      e && !r ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback), null != t && setTimeout(this.nextCallback, t)) : setTimeout(this.nextCallback, 0);
    }, t.render = function () {
      var e = this.state.status;
      if (e === Pe) return null;
      var t = this.props,
          n = t.children,
          r = be(t, ["children"]);
      if (delete r.in, delete r.mountOnEnter, delete r.unmountOnExit, delete r.appear, delete r.enter, delete r.exit, delete r.timeout, delete r.addEndListener, delete r.onEnter, delete r.onEntering, delete r.onEntered, delete r.onExit, delete r.onExiting, delete r.onExited, "function" == typeof n) return d.createElement(Te.Provider, {
        value: null
      }, n(e, r));
      var o = d.Children.only(n);
      return d.createElement(Te.Provider, {
        value: null
      }, d.cloneElement(o, r));
    }, e;
  }(d.Component);

  function Ve() {}

  Re.contextType = Te, Re.propTypes = "production" !== process.env.NODE_ENV ? {
    children: q([H.isRequired, B.isRequired]).isRequired,
    in: F,
    mountOnEnter: F,
    unmountOnExit: F,
    appear: F,
    enter: F,
    exit: F,
    timeout: function timeout(e) {
      var t = Ce;
      e.addEndListener || (t = t.isRequired);

      for (var n = arguments.length, r = new Array(1 < n ? n - 1 : 0), o = 1; o < n; o++) {
        r[o - 1] = arguments[o];
      }

      return t.apply(void 0, [e].concat(r));
    },
    addEndListener: H,
    onEnter: H,
    onEntering: H,
    onEntered: H,
    onExit: H,
    onExiting: H,
    onExited: H
  } : {}, Re.defaultProps = {
    in: !1,
    mountOnEnter: !1,
    unmountOnExit: !1,
    appear: !1,
    enter: !0,
    exit: !0,
    onEnter: Ve,
    onEntering: Ve,
    onEntered: Ve,
    onExit: Ve,
    onExiting: Ve,
    onExited: Ve
  }, Re.UNMOUNTED = 0, Re.EXITED = 1, Re.ENTERING = 2, Re.ENTERED = 3, Re.EXITING = 4;

  function Ae(t, e) {
    return t && e && e.split(" ").forEach(function (e) {
      return function (e, t) {
        e.classList ? e.classList.remove(t) : "string" == typeof e.className ? e.className = we(e.className, t) : e.setAttribute("class", we(e.className && e.className.baseVal || "", t));
      }(t, e);
    });
  }

  var De = function (r) {
    function e() {
      for (var o, e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      return (o = r.call.apply(r, [this].concat(t)) || this).appliedClasses = {
        appear: {},
        enter: {},
        exit: {}
      }, o.onEnter = function (e, t) {
        o.removeClasses(e, "exit"), o.addClass(e, t ? "appear" : "enter", "base"), o.props.onEnter && o.props.onEnter(e, t);
      }, o.onEntering = function (e, t) {
        var n = t ? "appear" : "enter";
        o.addClass(e, n, "active"), o.props.onEntering && o.props.onEntering(e, t);
      }, o.onEntered = function (e, t) {
        var n = t ? "appear" : "enter";
        o.removeClasses(e, n), o.addClass(e, n, "done"), o.props.onEntered && o.props.onEntered(e, t);
      }, o.onExit = function (e) {
        o.removeClasses(e, "appear"), o.removeClasses(e, "enter"), o.addClass(e, "exit", "base"), o.props.onExit && o.props.onExit(e);
      }, o.onExiting = function (e) {
        o.addClass(e, "exit", "active"), o.props.onExiting && o.props.onExiting(e);
      }, o.onExited = function (e) {
        o.removeClasses(e, "exit"), o.addClass(e, "exit", "done"), o.props.onExited && o.props.onExited(e);
      }, o.getClassNames = function (e) {
        var t = o.props.classNames,
            n = "string" == typeof t,
            r = n ? (n && t ? t + "-" : "") + e : t[e];
        return {
          baseClassName: r,
          activeClassName: n ? r + "-active" : t[e + "Active"],
          doneClassName: n ? r + "-done" : t[e + "Done"]
        };
      }, o;
    }

    ge(e, r);
    var t = e.prototype;
    return t.addClass = function (e, t, n) {
      var r = this.getClassNames(t)[n + "ClassName"];
      "appear" === t && "done" === n && (r += " " + this.getClassNames("enter").doneClassName), "active" === n && e && e.scrollTop, function (t, e) {
        t && e && e.split(" ").forEach(function (e) {
          return Oe(t, e);
        });
      }(e, this.appliedClasses[t][n] = r);
    }, t.removeClasses = function (e, t) {
      var n = this.appliedClasses[t],
          r = n.base,
          o = n.active,
          i = n.done;
      this.appliedClasses[t] = {}, r && Ae(e, r), o && Ae(e, o), i && Ae(e, i);
    }, t.render = function () {
      var e = this.props,
          t = (e.classNames, be(e, ["classNames"]));
      return d.createElement(Re, he({}, t, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }));
    }, e;
  }(d.Component);

  function $e(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function Ie(e, t) {
    var n = Object.create(null);
    return e && p.Children.map(e, function (e) {
      return e;
    }).forEach(function (e) {
      n[e.key] = function (e) {
        return t && p.isValidElement(e) ? t(e) : e;
      }(e);
    }), n;
  }

  function Le(e, t, n) {
    return null != n[t] ? n[t] : e.props[t];
  }

  function ze(a, s, u) {
    var c = Ie(a.children),
        l = function (t, n) {
      function e(e) {
        return e in n ? n[e] : t[e];
      }

      t = t || {}, n = n || {};
      var r,
          o = Object.create(null),
          i = [];

      for (var a in t) {
        a in n ? i.length && (o[a] = i, i = []) : i.push(a);
      }

      var s = {};

      for (var u in n) {
        if (o[u]) for (r = 0; r < o[u].length; r++) {
          var c = o[u][r];
          s[o[u][r]] = e(c);
        }
        s[u] = e(u);
      }

      for (r = 0; r < i.length; r++) {
        s[i[r]] = e(i[r]);
      }

      return s;
    }(s, c);

    return Object.keys(l).forEach(function (e) {
      var t = l[e];

      if (p.isValidElement(t)) {
        var n = (e in s),
            r = (e in c),
            o = s[e],
            i = p.isValidElement(o) && !o.props.in;
        !r || n && !i ? r || !n || i ? r && n && p.isValidElement(o) && (l[e] = p.cloneElement(t, {
          onExited: u.bind(null, t),
          in: o.props.in,
          exit: Le(t, "exit", a),
          enter: Le(t, "enter", a)
        })) : l[e] = p.cloneElement(t, {
          in: !1
        }) : l[e] = p.cloneElement(t, {
          onExited: u.bind(null, t),
          in: !0,
          exit: Le(t, "exit", a),
          enter: Le(t, "enter", a)
        });
      }
    }), l;
  }

  De.defaultProps = {
    classNames: ""
  }, De.propTypes = "production" !== process.env.NODE_ENV ? he({}, Re.propTypes, {
    classNames: Se,
    onEnter: H,
    onEntering: H,
    onEntered: H,
    onExit: H,
    onExiting: H,
    onExited: H
  }) : {};

  var Fe = Object.values || function (t) {
    return Object.keys(t).map(function (e) {
      return t[e];
    });
  },
      Be = function (o) {
    function e(e, t) {
      var n,
          r = (n = o.call(this, e, t) || this).handleExited.bind($e($e(n)));
      return n.state = {
        contextValue: {
          isMounting: !0
        },
        handleExited: r,
        firstRender: !0
      }, n;
    }

    ge(e, o);
    var t = e.prototype;
    return t.componentDidMount = function () {
      this.mounted = !0, this.setState({
        contextValue: {
          isMounting: !1
        }
      });
    }, t.componentWillUnmount = function () {
      this.mounted = !1;
    }, e.getDerivedStateFromProps = function (e, t) {
      var n = t.children,
          r = t.handleExited;
      return {
        children: t.firstRender ? function (t, n) {
          return Ie(t.children, function (e) {
            return p.cloneElement(e, {
              onExited: n.bind(null, e),
              in: !0,
              appear: Le(e, "appear", t),
              enter: Le(e, "enter", t),
              exit: Le(e, "exit", t)
            });
          });
        }(e, r) : ze(e, n, r),
        firstRender: !1
      };
    }, t.handleExited = function (n, e) {
      var t = Ie(this.props.children);
      n.key in t || (n.props.onExited && n.props.onExited(e), this.mounted && this.setState(function (e) {
        var t = he({}, e.children);
        return delete t[n.key], {
          children: t
        };
      }));
    }, t.render = function () {
      var e = this.props,
          t = e.component,
          n = e.childFactory,
          r = be(e, ["component", "childFactory"]),
          o = this.state.contextValue,
          i = Fe(this.state.children).map(n);
      return delete r.appear, delete r.enter, delete r.exit, null === t ? d.createElement(Te.Provider, {
        value: o
      }, i) : d.createElement(Te.Provider, {
        value: o
      }, d.createElement(t, r, i));
    }, e;
  }(d.Component);

  function He() {
    var e = v(["\n  &.react-snackbar-alert__snackbar-container-enter {\n    opacity: 0;\n    transform: scaleY(0.1);\n  }\n\n  &.react-snackbar-alert__snackbar-container-enter-active {\n    opacity: 1;\n    transform: scaleY(1);\n    transition: all ", "ms;\n  }\n\n  &.react-snackbar-alert__snackbar-container-exit {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n\n  &.react-snackbar-alert__snackbar-container-exit-active {\n    opacity: 0;\n    transform: scaleY(0.1);\n    transition: all ", "ms;\n  }\n"]);
    return He = function He() {
      return e;
    }, e;
  }

  function qe() {
    var e = v(["\n  position: fixed;\n  width: 20em;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  z-index: 10000;\n"]);
    return qe = function qe() {
      return e;
    }, e;
  }

  Be.propTypes = "production" !== process.env.NODE_ENV ? {
    component: z.any,
    children: z.node,
    appear: z.bool,
    enter: z.bool,
    exit: z.bool,
    childFactory: z.func
  } : {}, Be.defaultProps = {
    component: "div",
    childFactory: function childFactory(e) {
      return e;
    }
  };
  var We = r.div(qe(), function (e) {
    return 0 === e.position.indexOf("top") ? 0 : "inherit";
  }, function (e) {
    return 0 === e.position.indexOf("bottom") ? 0 : "inherit";
  }, function (e) {
    return function (e) {
      switch (e) {
        case "top":
        case "bottom":
          return "calc(50% - 10em)";

        case "top-left":
        case "bottom-left":
          return "0.5em";

        case "top-right":
        case "bottom-right":
          return "calc(100vw - 20.5em)";
      }
    }(e.position);
  }),
      Ue = r.div(He(), function (e) {
    return e.animationTimeout;
  }, function (e) {
    return e.animationTimeout;
  });

  function Ye(e) {
    var t = e.animationTimeout,
        n = e.component,
        r = e.dismissable,
        o = e.notifications,
        i = e.onPause,
        a = e.onRemove,
        s = e.onResume,
        u = e.pauseOnHover,
        c = e.position,
        l = e.progressBar,
        p = e.sticky,
        f = 0 === c.indexOf("top") ? h(o).reverse() : o;
    return d.createElement(We, {
      position: c
    }, d.createElement(Be, null, f.map(function (e) {
      return d.createElement(De, {
        key: e.key,
        timeout: e.animationTimeout || t,
        classNames: "react-snackbar-alert__snackbar-container"
      }, d.createElement(Ue, {
        animationTimeout: e.animationTimeout || t
      }, d.createElement(n, {
        progressBar: void 0 !== e.progressBar ? e.progressBar : l,
        sticky: void 0 !== e.sticky ? e.sticky : p,
        theme: e.theme || "default",
        timeout: e.timeout,
        dismissable: void 0 !== e.dismissable ? e.dismissable : r,
        onDismiss: function onDismiss() {
          return a(e);
        },
        onPause: function onPause() {
          return i(e);
        },
        onResume: function onResume() {
          return s(e);
        },
        pauseOnHover: void 0 !== e.pauseOnHover ? e.pauseOnHover : u,
        message: e.message,
        data: e.data,
        position: c
      })));
    })));
  }

  Ye.propTypes = {
    animationTimeout: z.number,
    component: z.elementType,
    dismissable: z.bool,
    notifications: z.array,
    onPause: z.func.isRequired,
    onRemove: z.func.isRequired,
    onResume: z.func.isRequired,
    pauseOnHover: z.bool,
    position: z.oneOf(["top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right"]),
    progressBar: z.bool,
    sticky: z.bool
  }, Ye.defaultProps = {
    animationTimeout: 250,
    component: pe,
    dismissable: !1,
    pauseOnHover: !1,
    position: "bottom",
    progressBar: !0,
    sticky: !1,
    timeout: 3e3
  };

  var Je = d.createContext(),
      Ge = Je.Consumer,
      Xe = function () {
    function n(e) {
      var t;
      return i(this, n), (t = y(this, l(n).call(this, e))).timeouts = {}, t.startTimes = {}, t.paused = {}, t.state = {
        notifications: []
      }, t.create = t.create.bind(m(t)), t.pause = t.pause.bind(m(t)), t.remove = t.remove.bind(m(t)), t.resume = t.resume.bind(m(t)), t;
    }

    return c(n, d.Component), s(n, [{
      key: "create",
      value: function value(t) {
        var n = this;
        t.key = ve(), void 0 === t.timeout && (t.timeout = this.props.timeout), void 0 === t.sticky && (t.sticky = this.props.sticky), this.setState({
          notifications: [].concat(h(this.state.notifications), [t])
        }, function () {
          if (!t.sticky) {
            n.startTimes[t.key] = Date.now();
            var e = setTimeout(function () {
              n.remove(t);
            }, t.timeout);
            n.timeouts[t.key] = e;
          }
        });
      }
    }, {
      key: "remove",
      value: function value(t) {
        clearTimeout(this.timeouts[t.key]), this.setState({
          notifications: this.state.notifications.filter(function (e) {
            return e !== t;
          })
        }), delete this.timeouts[t.key], delete this.paused[t.key], delete this.startTimes[t.key];
      }
    }, {
      key: "pause",
      value: function value(e) {
        if (!e.sticky) {
          clearTimeout(this.timeouts[e.key]), delete this.timeouts[e.key];
          var t = (this.paused[e.key] || e.timeout) - (Date.now() - this.startTimes[e.key]);
          this.paused[e.key] = t;
        }
      }
    }, {
      key: "resume",
      value: function value(e) {
        var t = this;

        if (!e.sticky) {
          var n = this.paused[e.key];
          this.startTimes[e.key] = Date.now();
          var r = setTimeout(function () {
            t.remove(e);
          }, n);
          this.timeouts[e.key] = r;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var t = this;
        Object.keys(this.timeouts).forEach(function (e) {
          clearTimeout(t.timeouts[e]);
        });
      }
    }, {
      key: "render",
      value: function value() {
        return d.createElement(Je.Provider, {
          value: {
            createSnackbar: this.create
          }
        }, d.createElement(Ye, {
          animationTimeout: this.props.animationTimeout,
          component: this.props.component,
          dismissable: this.props.dismissable,
          notifications: this.state.notifications,
          onPause: this.pause,
          onRemove: this.remove,
          onResume: this.resume,
          pauseOnHover: this.props.pauseOnHover,
          position: this.props.position,
          progressBar: this.props.progressBar,
          sticky: this.props.sticky,
          timeout: this.props.timeout
        }), this.props.children);
      }
    }]), n;
  }();

  Xe.defaultProps = {
    animationTimeout: 250,
    component: pe,
    dismissable: !1,
    pauseOnHover: !1,
    position: "bottom",
    progressBar: !0,
    sticky: !1,
    timeout: 3e3
  }, Xe.propTypes = {
    animationTimeout: z.number,
    children: z.node,
    component: z.elementType,
    dismissable: z.bool,
    pauseOnHover: z.bool,
    progressBar: z.bool,
    position: z.oneOf(["top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right"]),
    sticky: z.bool,
    timeout: z.number
  }, e.Snackbar = pe, e.SnackbarConsumer = Ge, e.SnackbarContext = Je, e.SnackbarProvider = Xe, e.wrapComponent = function (n) {
    return function (e) {
      var t = p.useContext(Je).createSnackbar;
      return d.createElement(n, u({
        createSnackbar: t
      }, e));
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});